/**
 * Global ambifi context
 */

let ambifi = {};

export default ambifi;